import { combineReducers } from 'redux';
import getAutomatedReports from 'store/reducers/automated-report/get-automated-reports';
import postAutomatedReport from 'store/reducers/automated-report/post-automated-report';
import getAutomatedReport from 'store/reducers/automated-report/get-automated-report';
import deleteAutomatedReport from 'store/reducers/automated-report/delete-automated-report';

export default combineReducers({
  getAutomatedReports,
  postAutomatedReport,
  getAutomatedReport,
  deleteAutomatedReport,
});
